import { Box } from '@mui/material'
import axios from 'axios'
import type { FC } from 'react'
import { Outlet } from 'react-router'

export const InsecureZone: FC = () => {
	axios.interceptors.request.eject(0)
	axios.interceptors.response.eject(0)

	return (
		<Box display="flex" height="100vh">
			<Outlet />
		</Box>
	)
}
